import { Col, Form, Input, Row } from 'antd';
import classNames from 'classnames/bind';
import { checkKeyDownNumberInput } from '~/utils';
import styles from './InputPhoneModal.module.scss';

const cx = classNames.bind(styles);

const InputPhoneModal = ({ onAgreeInputPhone }) => {
    const [form] = Form.useForm();
    const onFinish = (data) => {
        localStorage.setItem('phone_booking', data.phone);
        onAgreeInputPhone();
    };
    return (
        <Form onFinish={onFinish} form={form}>
            <Form.Item>
                <Row className={cx('name_page')}>Schedule quickly within 30 seconds</Row>
            </Form.Item>

            <Row style={{ marginTop: '40px' }} justify="center">
                <Col xs={24} sm={14}>
                    <Form.Item
                        name="phone"
                        rules={[
                            { required: true, message: 'Please enter phone number' },
                            {
                                // pattern: new RegExp(/^[0-9\S]*$/),
                                pattern: new RegExp(/(0[3|5|7|8|9])+([0-9])/),
                                message: 'Wrong phone number format',
                            },
                            { min: 10, message: 'Phone number must have 10 digits' },
                        ]}
                    >
                        <div>
                            <Input
                                placeholder="Phone number *"
                                maxLength={10}
                                className={cx('item_input')}
                                onKeyDown={checkKeyDownNumberInput}
                                // autoComplete="off"
                            />
                        </div>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={10}>
                    <Row justify="end">
                        <button htmlType="submit" className={cx('btn_logout')}>
                            Schedule now
                        </button>
                    </Row>
                </Col>
            </Row>
        </Form>
    );
};

export default InputPhoneModal;
